<template>
  <el-form v-bind="formProps" v-on="$listeners">
    <edit-item ref="editItem"
      :editable="editable"
      :item="itemCopy">
      <template slot="key" slot-scope="scope">
        <slot v-bind="scope"></slot>
      </template>
    </edit-item>
  </el-form>
</template>

<script>
// editItem组件通过mixins带进来了
import editItem from '../edit-item'
// import { deepCopy } from '@/utils/utils'
export default {
  name: 'EditCell',
  components: {
    editItem // 单元组件
  },
  data () {
    return {
      itemCopy: this.handleItem()
    }
  },
  props: {
    editable: Boolean,
    // inline: {
    //   type: Boolean,
    //   default: false
    // },
    item: Object,
    value: null,
    // label: String,
    // type: String,
    // on: Object,
    // props: Object,
    // text: String,
    // rules: null,
    // options: Array,
    // class: String,
    // required: Boolean,
    // itemProps: null,
    // statusIcon: {
    //   type: Boolean,
    //   default: true
    // },
    formProps: {
      type: Object,
      default: () => {
        return {
          labelWidth: '0'
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    'item': {
      deep: true,
      handler: function (n, o) {
        this.itemCopy && Object.assign(this.itemCopy, n)
      }
    },
    'itemCopy.value': function (n, o) {
      this.$emit('input', n)
    }
  },
  methods: {
    handleItem () {
      return {
        key: 'key',
        statusIcon: true,
        slots: this.$slots && this.$slots.default,
        ...this.item,
        value: this.value
      }
    },
    validate () {
      return this.$refs.editItem.validate()
    }
  },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
// .form-item-box
  // min-width 300px
</style>
